export enum UzurvDataSource {
  Clara = 'CLARA',
  Medusa = 'MEDUSA'
}
